import { render, staticRenderFns } from "./ReviewCarousel.vue?vue&type=template&id=e1638a48&scoped=true&lang=pug&"
import script from "./ReviewCarousel.vue?vue&type=script&lang=js&"
export * from "./ReviewCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCarousel.vue?vue&type=style&index=0&id=e1638a48&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1638a48",
  null
  
)

export default component.exports